import { render } from "./TheCoin.vue?vue&type=template&id=3622e916"
import script from "./TheCoin.vue?vue&type=script&lang=js"
export * from "./TheCoin.vue?vue&type=script&lang=js"

import "./TheCoin.vue?vue&type=style&index=0&id=3622e916&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__